import Vue from 'vue';
import Vuex from 'vuex';

import ui from './modules/ui';
import auth from './modules/auth';
import clients from './modules/clients';
import groups from './modules/groups';
import devices from './modules/devices';
import monitors from './modules/monitors';
import translatorServers from './modules/translator_servers';
import connections from './modules/connections';
import users from './modules/users';
import sidebar from './modules/sidebar';
import settings from './modules/settings';
import cwPlugin from './modules/cw_plugin';
import metrics from './modules/metrics';
import roles from './modules/roles';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		ui,
		auth,
		clients,
		groups,
		devices,
		monitors,
		translatorServers,
		connections,
		users,
		sidebar,
		settings,
		cwPlugin,
		metrics,
		roles
	}
});
